<template>
    <div class="field">
        <div class="name" v-if="!hide_name">{{ name ? name + ':' : '' }}</div>
        <div :class="!hide_name ? 'value' : (hide_name_class ? hide_name_class : '')">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            hide_name: {
                type: Boolean,
                default: false
            },
            hide_name_class: String
        }
    }
</script>